/* GRIG Shopify theme JS — AJAX cart, free-ship progress, reveal, consent/tracking scaffold */
(function(){
  var $ = function(s,r){return (r||document).querySelector(s);};
  var FREE = Number(window.GRIG_FREE_SHIPPING);
  if (!Number.isFinite(FREE) || FREE < 0) FREE = 4900;
  var ROUTES = window.GRIG_ROUTES;
  var T = window.GRIG_I18N;
  var priceLocale = /^(de|fr|cs)(-|$)/i.test(document.documentElement.lang) ? document.documentElement.lang : 'en';
  var priceCurrency = window.GRIG_CURRENCY || 'EUR';
  var priceFormat = new Intl.NumberFormat(priceLocale, {
    style: 'currency', currency: priceCurrency,
    minimumFractionDigits: priceCurrency === 'CZK' ? 0 : 2, maximumFractionDigits: 2
  });

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function money(cents){ return priceFormat.format(cents / 100); }

  function unitPrice(item){
    var m = item.unit_price_measurement;
    if (!m || item.unit_price == null || !m.reference_unit) return '';
    if (window.GRIG_COUNTRY === 'DE') {
      var grams = 10, quantity = Number(m.quantity_value) || 0;
      switch (m.quantity_unit) {
        case 'g': grams = quantity; break;
        case 'kg': grams = quantity * 1000; break;
        case 'mg': grams = quantity / 1000; break;
      }
      if (grams < 10) return '';
    }
    var reference = Number(m.reference_value) || 1;
    return '<small class="dr-unit">(' + esc(money(item.unit_price)) + '/' +
      esc((reference === 1 ? '' : reference + ' ') + m.reference_unit) + ')</small>';
  }

  /* header shrink */
  var hdr = $('#hdr');
  addEventListener('scroll', function(){ if(hdr) hdr.classList.toggle('scrolled', scrollY>16); }, {passive:true});

  /* Reveals are progressively enhanced by grig-motion.js. */

  /* toast */
  var tT; function toast(m){var t=$('#toast');if(!t)return;$('#toastTxt').textContent=m;t.classList.add('show');clearTimeout(tT);tT=setTimeout(function(){t.classList.remove('show');},2200);}

  /* cart drawer */
  var drawer = $('#drawer'), scrim = $('#scrim');
  var cartState = null, cartBusy = false, cartRevision = 0;
  var productCache = new Map();
  var localizedImages = {};
  try { localizedImages = JSON.parse(($('#grigCartImages') || {}).textContent || '{}') || {}; }
  catch (error) { localizedImages = {}; }
  var imageLang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  if (!/^(cs|de|fr)$/.test(imageLang)) imageLang = 'en';


  function openCart(o){
    if (drawer) drawer.classList.toggle('open', o);
    if (scrim) scrim.classList.toggle('open', o);
    if (o && $('#toast')) { clearTimeout(tT); $('#toast').classList.remove('show'); }
  }
  function cartError(message){
    var el = $('#drError');
    if (el) { el.textContent = message; el.hidden = !message; }
    if (message && (!drawer || !drawer.classList.contains('open'))) toast(message);
  }
  async function cartJSON(url, options){
    var response = await fetch(url, options || {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!response.ok) throw new Error(T.updateError);
    return response.json();
  }
  async function getCart(){
    var cart=await cartJSON(ROUTES.cart + '.js');
    return window.GRIGMerch && GRIGMerch.enrichCart ? GRIGMerch.enrichCart(cart) : cart;
  }
  function postCart(route, data){
    return cartJSON(route + '.js', {
      method:'POST', headers:{Accept:'application/json', 'Content-Type':'application/json'},
      body:JSON.stringify(data)
    });
  }
  function cartControls(){
    if (!drawer) return;
    drawer.setAttribute('aria-busy', String(cartBusy));
    drawer.querySelectorAll('[data-dr-change]').forEach(function(b){ b.disabled = cartBusy || !cartState; });
    var continueLink = $('#drContinue');
    var inactive = cartBusy || !cartState || !cartState.item_count;
    if (continueLink) {
      continueLink.setAttribute('aria-disabled', String(inactive));
      if (inactive) continueLink.removeAttribute('href');
      else continueLink.setAttribute('href', ROUTES.cart);
    }
  }
  function quantityButton(item, quantity, label, symbol, className){
    return '<button type="button" class="' + (className || 'dr-qty-button') + '" data-dr-change="' + esc(item.key) +
      '" data-quantity="' + quantity + '" data-gmu-label="' + label + '">' + symbol + '</button>';
  }
  function renderCart(c){
    cartState = c;
    if ($('#cnt')) $('#cnt').textContent = c.item_count;
    if ($('#dtot')) $('#dtot').textContent = money(c.total_price);
    var items = $('#ditems');
    if (items) items.innerHTML = c.items.map(function(i){
      var image = localizedImages[i.variant_id] || (i.image && (typeof i.image === 'string' ? i.image : i.image.src)) ||
        (i.featured_image && i.featured_image.url);
      return '<div class="dr-item"><div class="dr-image">' +
        (image ? '<img src="' + esc(image) +
          '" alt="' + esc(i.product_title) + '" width="64" height="64" loading="lazy" decoding="async">' : '') +
        '</div><div class="dr-details"><span class="dr-title">' + esc(String(i.product_title || '').replace(/ (g)$/i, '\u00a0$1')) + '</span>' +
        (i.variant_title && i.variant_title !== 'Default Title' ? '<small class="dr-variant">' + esc(i.variant_title) + '</small>' : '') +
        unitPrice(i) + '</div><div class="dr-price"><span class="p">' +
        esc(money(i.final_line_price == null ? i.line_price : i.final_line_price)) + '</span></div>' +
        '<div class="dr-actions"><div class="dr-quantity">' + quantityButton(i, i.quantity - 1, 'decrease', '−') +
        '<span>' + i.quantity + '</span>' + quantityButton(i, i.quantity + 1, 'increase', '+') + '</div>' +
        quantityButton(i, 0, 'remove', '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
          '<path d="M3 6h18M9 6V4h6v2M5 6l1 14h12l1-14M10 10v6M14 10v6"/></svg>', 'dr-remove') +
        '</div></div>';
    }).join('');
    if (items) {
      items.querySelectorAll('[data-gmu-label]').forEach(function(button){
        var item = c.items.find(function(i){ return i.key === button.dataset.drChange; });
        button.setAttribute('aria-label', T[button.dataset.gmuLabel] + ' ' + item.product_title);
      });
      if (!c.items.length) {
        var empty = $('#gmEmptyCart');
        if (empty) items.append(empty.content.cloneNode(true));
        else {
          var message = document.createElement('div');
          message.className = 'dempty'; message.textContent = T.empty; items.append(message);
        }
      }
    }
    if ($('.ship', drawer)) $('.ship', drawer).hidden = !['EUR', 'CZK'].includes(priceCurrency);
    var progress = FREE === 0 ? 1 : Math.max(0, Math.min(c.total_price / FREE, 1));
    if ($('#shipBar')) $('#shipBar').style.transform = 'scaleX(' + progress + ')';
    if ($('#shipTxt')) $('#shipTxt').textContent = c.total_price >= FREE ? T.freeship :
      T.shipmore.replace('{amount}', money(FREE - c.total_price));
    var runner = $('#gmRunner'), unlocked = c.total_price >= FREE;
    if (runner) {
      runner.style.transform = 'translateX(' + (progress * 100) + '%)';
      var pose = $('img', runner), source = unlocked ? pose.dataset.cheer : pose.dataset.run;
      if (pose.getAttribute('src') !== source) { pose.hidden = false; pose.dataset.gmSrc = source; }
      else delete pose.dataset.gmSrc;
    }
    document.dispatchEvent(new Event('grig:art'));
    if ($('#gmShipTruck')) $('#gmShipTruck').hidden = unlocked;
    if ($('#gmShipSparkle')) $('#gmShipSparkle').hidden = !unlocked;
    cartControls();
  }
  function productURL(handle){
    return ROUTES.root.replace(/\/+$/, '') + '/products/' + encodeURIComponent(handle) + '.js';
  }
  function loadProduct(handle){
    if (!productCache.has(handle)) productCache.set(handle, cartJSON(productURL(handle)).catch(function(){
      productCache.delete(handle);
      return null;
    }));
    return productCache.get(handle);
  }
  function imageSlug(title){
    return String(title || 'Default Title').toLowerCase().replace(/ & /g, '-').replace(/ /g, '-');
  }
  function imageMarkers(variant, localizedTitle){
    var names = [variant && variant.title, localizedTitle];
    var english = {'chili':'chilli','piment':'chilli','käse':'cheese','fromage':'cheese','sýr':'cheese',
      'salz':'salt','sel':'salt','sůl':'salt','speck':'bacon','slanina':'bacon',
      'chili-limette':'chilli-lime','piment-et-citron-vert':'chilli-lime',
      'knoblauch':'garlic','ail':'garlic','česnek':'garlic','meersalz':'sea-salt',
      'sel-marin':'sea-salt','mořská-sůl':'sea-salt'};
    var markers = [];
    names.forEach(function(name){
      var slug = imageSlug(name), mapped = english[slug] || slug;
      markers.push('[var:' + slug + ']', '[var:' + mapped + ']');
    });
    return markers;
  }
  function chooseCartImage(product, variant, width, localizedTitle){
    if (!product) return '';
    var media = Array.isArray(product.media) ? product.media : [];
    var markers = imageMarkers(variant, localizedTitle), chosen = null, rank = 99;
    media.forEach(function(m){
      if (!m || (m.media_type && m.media_type !== 'image')) return;
      var alt = String(m.alt || '').toLowerCase();
      if (alt.includes('[hide:' + imageLang + ']') || alt.includes('on white') || alt.includes('white background')) return;
      var local = alt.includes('[lang:' + imageLang + ']'), english = alt.includes('[lang:en]');
      if (!local && !english) return;
      var hasVariant = alt.includes('[var:');
      var matchesVariant = markers.some(function(marker){ return alt.includes(marker); });
      if (hasVariant && !matchesVariant) return;
      var mediaSource = m.src || (m.preview_image && m.preview_image.src) || m.url;
      if (!mediaSource) return;
      var packshot = alt.includes('packshot');
      var score = local
        ? (matchesVariant ? (packshot ? 0 : 1) : (packshot ? 2 : 6))
        : (matchesVariant ? (packshot ? 3 : 4) : (packshot ? 5 : 7));
      if (score < rank) { chosen = mediaSource; rank = score; }
    });
    var featured = product.featured_image;
    var source = chosen || (typeof featured === 'string' ? featured : featured && (featured.src || featured.url));
    if (!source) return '';
    try {
      var url = new URL(source, window.location.href);
      if (url.protocol !== 'https:') return '';
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) { return ''; }
  }
  async function localizeCartImages(c){
    var changed = await Promise.all((c.items || []).map(async function(item){
      if (!item || localizedImages[item.variant_id] || !item.handle) return false;
      var product = await loadProduct(item.handle);
      var variant = product && Array.isArray(product.variants) && product.variants.find(function(v){
        return v && String(v.id) === String(item.variant_id);
      });
      var image = chooseCartImage(product, variant, 144, item.variant_title);
      if (!image) return false;
      localizedImages[item.variant_id] = image;
      return true;
    }));
    return changed.some(Boolean);
  }
  async function refreshCart(){
    var revision = ++cartRevision;
    var c;
    try { c = await getCart(); }
    catch (error) { if (revision !== cartRevision) return cartState; throw error; }
    if (revision !== cartRevision) return c;
    renderCart(c);
    localizeCartImages(c).then(function(changed){
      if (changed && revision === cartRevision) renderCart(c);
    }).catch(function(){ /* Optional image localization must not block the cart. */ });
    document.dispatchEvent(new CustomEvent('grig:cart-updated', {detail:{cart:c}}));
    return c;
  }
  function cartBusyEvent(){
    document.dispatchEvent(new CustomEvent('grig:cart-busy', {detail:{busy:cartBusy}}));
  }
  async function mutateCart(action, errorMessage){
    if (cartBusy) return {ok:false, busy:true, cart:cartState};
    cartBusy = true;
    ++cartRevision;
    cartError(''); cartControls(); cartBusyEvent();
    var ok = false, payload = null, reason = null;
    async function execute(){
      try { payload = await action(); ok = true; }
      catch (error) { reason = error.code || 'request_failed'; cartError(errorMessage); }
      finally {
        try { await refreshCart(); }
        catch (error) { cartState = null; cartError(T.loadError); }
      }
    }
    try {
      if (navigator.locks && navigator.locks.request) await navigator.locks.request('grig-cart-mutation', execute);
      else await execute();
    } finally { cartBusy = false; cartControls(); cartBusyEvent(); }
    return {ok:ok, payload:payload, cart:cartState, reason:reason};
  }

  function notifyAdded(payload, requested, options){
    if (window.trackAddToCartItems) {
      try { window.trackAddToCartItems(payload, requested, options.source || 'product'); }
      catch (error) { /* Measurement cannot interrupt the successful addition. */ }
    }
    if (window.GRIG) {
      var motionTarget = options.button && options.button.isConnected ? options.button : $('#cartBtn');
      GRIG.crunch(motionTarget); GRIG.thumbs(T.grig_added);
    }
    if (options.openDrawer !== false) openCart(true);
    document.dispatchEvent(new CustomEvent('grig:cart-added', {
      detail:{form:options.form || null, items:requested, source:options.source || 'product'}
    }));
  }
  function notifyAddError(options, result){
    document.dispatchEvent(new CustomEvent('grig:cart-error', {
      detail:{form:options.form || null, source:options.source || 'product', reason:result && result.reason}
    }));
  }
  window.GRIGCart = {
    get state(){ return cartState; },
    get busy(){ return cartBusy; },
    addItems:async function(items, options){
      options = options || {};
      if (!Array.isArray(items) || !items.length || items.some(function(item){
        return !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 ||
          !Number.isInteger(Number(item.quantity)) || Number(item.quantity) <= 0;
      })) return {ok:false, cart:cartState};
      var result = await mutateCart(async function(){
        if (options.validate) await options.validate(await getCart());
        return postCart(ROUTES.add, {items:items});
      }, T.err);
      if (result.ok) notifyAdded(result.payload, items, options);
      else notifyAddError(options,result);
      return result;
    },
    swapBox:async function(spec, options){
      options = options || {};
      if (!window.GRIGMerch || !window.crypto || !crypto.randomUUID) return {ok:false,cart:cartState,reason:'swap_changed'};
      spec = Object.assign({},spec,{token:'grig-v1-'+crypto.randomUUID()});
      var result = await mutateCart(function(){
        return GRIGMerch.swapTransaction(spec, {
          read:getCart,
          add:function(items){return postCart(ROUTES.add,{items:items});},
          change:function(key,quantity){return postCart(ROUTES.change,{id:key,quantity:quantity});}
        },options.validate);
      },T.updateError);
      if(result.ok)notifyAdded(result.payload,[{id:spec.targetVariantId,quantity:1}],options);
      else notifyAddError(options,result);
      return result;
    },
    change:async function(key, quantity){
      if (!key || !Number.isInteger(quantity) || quantity < 0) return {ok:false,cart:cartState};
      return mutateCart(function(){ return postCart(ROUTES.change, {id:key,quantity:quantity}); },T.updateError);
    }
  };
  if (drawer) drawer.addEventListener('click', function(e){
    var change = e.target.closest('[data-dr-change]');
    if (cartBusy || !change) return;
    window.GRIGCart.change(change.dataset.drChange, Number(change.dataset.quantity));
  });
  window.refreshCart = function(){
    return refreshCart().catch(function(){ cartState = null; cartControls(); cartError(T.loadError); });
  };
  if ($('#cartBtn')) $('#cartBtn').onclick = function(){ openCart(true); window.refreshCart(); };
  if ($('#closeCart')) $('#closeCart').onclick = function(){ openCart(false); };
  if (scrim) scrim.onclick = function(){ openCart(false); };
  /* AJAX add to cart */
  document.addEventListener('submit', function(e){
    var f = e.target.closest('form[data-grig-add]');
    if (!f) return;
    e.preventDefault();
    if (cartBusy) return;
    var fd = new FormData(f);
    var submitButton = e.submitter || f.querySelector('button[type="submit"]');
    var requested = window.GRIGMerch ? GRIGMerch.requestedItems(fd) : [];
    var options = {form:f,button:submitButton,source:f.dataset.grigSource || 'product'};
    mutateCart(async function(){
      if (typeof f.grigValidate === 'function') await f.grigValidate(await getCart());
      return cartJSON(ROUTES.add + '.js', {method:'POST', headers:{Accept:'application/json'}, body:fd});
    }, T.err).then(function(result){
      if (result.ok) notifyAdded(result.payload, requested, options);
      else notifyAddError(options,result);
    });
  });

  window.refreshCart();

  /* ===== Souhlas s cookies: kategorie + Consent Mode v2 + Shopify Customer Privacy API ===== */
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(){ dataLayer.push(arguments); };
  var IDS = window.GRIG_IDS || {};
  var CUR = window.GRIG_CURRENCY || 'EUR';
  var KEY = 'grig_consent_v2';
  var MAXAGE = 365 * 864e5;   /* souhlas se po roce znovu zeptá */

  gtag('consent','default',{ad_storage:'denied',analytics_storage:'denied',
    ad_user_data:'denied',ad_personalization:'denied',functionality_storage:'granted',
    security_storage:'granted'});

  function set(v){ return v && String(v).indexOf('XXX') === -1 && String(v).trim() !== ''; }

  function loadAnalytics(marketing){
    var clarityID = String(window.GRIG_CLARITY_ID || '').trim();
    if (/^[a-z0-9]+$/i.test(clarityID)) {
      if (!window.__grigClarity) {
        window.__grigClarity = true;
        window.clarity = window.clarity || function(){
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
        var clarityScript = document.createElement('script');
        clarityScript.defer = true;
        clarityScript.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(clarityID);
        window.clarity('consent');
        document.head.appendChild(clarityScript);
      }
      window.clarity('consentv2', {
        analytics_Storage: 'granted', ad_Storage: marketing ? 'granted' : 'denied'
      });
    }
    if(!set(IDS.ga4) || window.__grigGA) return; window.__grigGA = 1;
    var s = document.createElement('script'); s.async = 1;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + IDS.ga4;
    document.head.appendChild(s);
    gtag('js', new Date()); gtag('config', IDS.ga4);
  }
  function loadMarketing(){
    if(set(IDS.metaPixel) && !window.__grigFB){ window.__grigFB = 1;
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
      s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', IDS.metaPixel); fbq('track','PageView');
    }
  }

  function apply(a, m){
    gtag('consent','update',{
      analytics_storage: a ? 'granted' : 'denied',
      ad_storage:        m ? 'granted' : 'denied',
      ad_user_data:      m ? 'granted' : 'denied',
      ad_personalization:m ? 'granted' : 'denied'
    });
    /* Shopify vlastní měření a aplikační pixely se řídí tímhle, ne naším gtagem */
    try {
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function(err){
          if (err || !Shopify.customerPrivacy) return;
          Shopify.customerPrivacy.setTrackingConsent(
            {analytics: !!a, marketing: !!m, preferences: !!a, sale_of_data: !!m},
            function(){}
          );
        });
      }
    } catch(e){}
    if (a) loadAnalytics(m);
    else if (window.__grigClarity && window.clarity) {
      window.clarity('consent', false);
      window.clarity('consentv2', {analytics_Storage:'denied', ad_Storage:'denied'});
    }
    if (m) loadMarketing();
  }

  function load(){
    try { var o = JSON.parse(localStorage.getItem(KEY));
      if (!o || !o.t || (Date.now() - o.t) > MAXAGE) return null; return o;
    } catch(e){ return null; }
  }
  function save(a, m){
    try { localStorage.setItem(KEY, JSON.stringify({a:!!a, m:!!m, t:Date.now()})); } catch(e){}
    apply(a, m);
  }

  var box = $('#consent'), opts = $('#ckOptions'), btnSave = $('#ckSave'), btnCust = $('#ckCustomise');
  var btnConsentClose = $('#ckClose');
  function preferences(expanded){
    if (!box) return;
    box.classList.toggle('grig-consent-expanded', expanded);
    box.setAttribute('role', expanded ? 'dialog' : 'region');
    if (expanded) box.setAttribute('aria-modal', 'true');
    else box.removeAttribute('aria-modal');
    if (opts) opts.style.display = expanded ? 'block' : 'none';
    if (btnSave) btnSave.style.display = expanded ? 'block' : 'none';
    if (btnCust) {
      btnCust.style.display = expanded ? 'none' : 'block';
      btnCust.setAttribute('aria-expanded', String(expanded));
    }
    if (btnConsentClose) btnConsentClose.hidden = !expanded;
  }
  function show(){ if(box) box.style.display = 'block'; }
  function hide(){ if(box) box.style.display = 'none'; preferences(false); }
  function openPreferences(){
    var s = load(), cA = $('#ck-analytics'), cM = $('#ck-marketing');
    if (cA) cA.checked = !!(s && s.a);
    if (cM) cM.checked = !!(s && s.m);
    preferences(true);
    show();
  }
  function closePreferences(){
    // Discard unsaved choices. First visitors return to the nonmodal notice.
    if (load()) hide();
    else preferences(false);
  }

  var saved = load();
  if (saved) { apply(saved.a, saved.m); } else { show(); }

  if (box) {
    var cA = $('#ck-analytics'), cM = $('#ck-marketing');
    $('#ckAccept').onclick = function(){ save(true, true); hide(); };
    $('#ckReject').onclick = function(){ save(false, false); hide(); };
    if (btnCust) btnCust.onclick = openPreferences;
    if (btnConsentClose) btnConsentClose.onclick = closePreferences;
    if (btnSave) btnSave.onclick = function(){
      save(cA && cA.checked, cM && cM.checked); hide();
    };
  }
  var reopen = $('#ckReopen');
  if (reopen) reopen.onclick = function(ev){
    ev.preventDefault();
    openPreferences();
  };

  window.trackAddToCartItems = function(payload, requested, source){
    var consent = load();
    if (!consent || (!consent.a && !consent.m)) return;
    var rows = window.GRIGMerch ? GRIGMerch.analyticsItems(payload, requested) : [];
    if (!rows.length) return;
    var value = rows.reduce(function(sum,item){ return sum + item.price * item.quantity; },0);
    value = Math.round(value * 100) / 100;
    if (consent.a) {
      dataLayer.push({ecommerce:null});
      dataLayer.push({event:'add_to_cart', ecommerce:{currency:CUR,value:value,items:rows},grig_source:source});
    }
    if (consent.m && window.fbq) fbq('track','AddToCart',{
      content_ids:rows.map(function(item){return item.item_variant;}),content_type:'product',
      contents:rows.map(function(item){return {id:item.item_variant,quantity:item.quantity,item_price:item.price};}),
      value:value,currency:CUR
    });
  };

  /* GRIG_AOV_ANALYTICS_BEGIN: interaction events, never another ecommerce add. */
  document.addEventListener('grig:offer-interaction', function(event){
    var consent=load(), detail=event.detail || {};
    var currentTheme=window.Shopify && window.Shopify.theme;
    // Private theme tests must not become production performance data.
    if(!currentTheme || currentTheme.role!=='main' || !consent || !consent.a)return;
    if(!['impression','click','add','upgrade','goal_reached','goal_lost'].includes(detail.event))return;
    if(!['home','collection','pdp','mix','drawer','cart'].includes(detail.surface))return;
    if(typeof detail.kind!=='string' || !/^[a-z][a-z0-9_]{0,40}$/.test(detail.kind))return;
    if(!['EUR','CZK'].includes(detail.currency))return;
    var ids=detail.variantIds, quantities=detail.quantities;
    if(!Array.isArray(ids) || !Array.isArray(quantities) || ids.length!==quantities.length || ids.length>12)return;
    if(ids.some(function(id){return typeof id!=='string' || !/^[0-9]{1,18}$/.test(id);}))return;
    if(quantities.some(function(q){return !Number.isSafeInteger(q) || q<1;}))return;
    if(!Number.isSafeInteger(detail.valueCents) || detail.valueCents<0)return;
    var data={offer_surface:detail.surface,offer_kind:detail.kind,variant_ids:ids.join(','),
      quantities:quantities.join(','),offer_amount:detail.valueCents/100,currency:detail.currency};
    if(Number.isSafeInteger(detail.threshold) && detail.threshold>=0 && ['sachets','cents'].includes(detail.thresholdUnit)){
      data.threshold=detail.threshold;data.threshold_unit=detail.thresholdUnit;
    }
    if(typeof detail.contextProductId==='string' && /^[0-9]{1,18}$/.test(detail.contextProductId))data.context_product_id=detail.contextProductId;
    gtag('event','aov_offer_'+detail.event,data);
  });
  /* GRIG_AOV_ANALYTICS_END */

  var giftCompletions = new Set();
  try { JSON.parse(sessionStorage.getItem('grig_gift_completions') || '[]').forEach(function(key){giftCompletions.add(key);}); } catch (_) {}
  document.addEventListener('grig:gift-result', function(event){
    var consent=load(), detail=event.detail || {};
    if (!consent || !consent.a || detail.trigger!=='submit') return;
    var allowed={occasion:['christmas','birthday','secret_santa','party','just_because'],
      recipient:['partner','family','colleague','friend','group'],appetite:['variety','easy','all'],recommendation:['trio','dare','range']};
    if (!Object.keys(allowed).every(function(key){return allowed[key].includes(detail[key]);})) return;
    var values={occasion:detail.occasion,recipient:detail.recipient,appetite:detail.appetite,recommendation:detail.recommendation};
    var signature=Object.values(values).join('|');
    if(giftCompletions.has(signature))return;
    giftCompletions.add(signature);
    try { sessionStorage.setItem('grig_gift_completions',JSON.stringify(Array.from(giftCompletions))); } catch (_) {}
    gtag('event','gift_finder_complete',values);
  });

    /* hamburger */
  var hbg = document.getElementById('hamburger');
  var mob = document.getElementById('mobileMenu');
  if (hbg && mob) {
    hbg.addEventListener('click', function() {
      var open = mob.classList.toggle('open');
      hbg.classList.toggle('open', open);
      hbg.setAttribute('aria-expanded', open);
    });
    mob.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        mob.classList.remove('open');
        hbg.classList.remove('open');
        hbg.setAttribute('aria-expanded', false);
      });
    });
  }
  var closeBtn = document.getElementById('mobileClose');
if (closeBtn) {
  closeBtn.addEventListener('click', function() {
    mob.classList.remove('open');
    hbg.classList.remove('open');
    hbg.setAttribute('aria-expanded', false);
  });
}


})();

/* Reserve mobile space only for visible cookie controls, without changing consent. */
(function(){
  var box = document.getElementById('consent');
  if (!box) return;
  var bar = document.getElementById('grig-sticky-atc'), pending = 0;
  function measure(){
    pending = 0;
    var rect = box.getBoundingClientRect(), style = getComputedStyle(box);
    var visible = matchMedia('(max-width:760px)').matches && !box.hidden &&
      style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
    var bottom = visible ? Math.max(0, innerHeight - rect.bottom) : 0;
    var offset = visible ? Math.ceil(rect.height + bottom + 8) : 0;
    var barHeight = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    var viewportTop = window.visualViewport ? window.visualViewport.offsetTop : 0;
    var tall = visible && !!bar && rect.top - viewportTop < barHeight + 96;
    document.body.style.setProperty('--grig-consent-offset', offset + 'px');
    document.body.classList.toggle('grig-consent-visible', visible);
    document.body.classList.toggle('grig-consent-tall', tall);
  }
  function queue(){ if (!pending) pending = requestAnimationFrame(measure); }
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(queue);
    resizeObserver.observe(box);
    if (bar) resizeObserver.observe(bar);
  }
  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(queue);
    mutationObserver.observe(box, {attributes:true,subtree:true,attributeFilter:['style','class','hidden']});
    if (bar) mutationObserver.observe(bar, {attributes:true,attributeFilter:['class']});
  }
  document.addEventListener('click', function(event){
    var reopen = document.getElementById('ckReopen');
    if (box.contains(event.target) || (reopen && reopen.contains(event.target))) queue();
  }, true);
  addEventListener('resize', queue, {passive:true});
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queue, {passive:true});
    window.visualViewport.addEventListener('scroll', queue, {passive:true});
  }
  if (document.fonts) document.fonts.ready.then(queue);
  measure();
})();

